import { Box, Divider, Typography, useMediaQuery, useTheme } from '@mui/material';
import { IMedia, IUnSdg } from 'src/types';

import { MediaList } from '../media-list';
import { AvatarImg } from '../step-info/step-company.styled';
import { UnSdgList } from '../impacts-cards-ver/un-sdg-list.component';
import { ImageCarousel } from '../image-carousel';
import { LikesCounter } from '../impacts-cards-ver/likes-counter.component';
import { WorldHeartIcon } from 'src/assets/icons/v2/WorldHeartIcon';
import { AIGeneratedBanner } from '../ai-generated-banner';
import { RichDescription } from '../rich-description';

interface IProps {
  title: string | number;
  subtitle: string;
  image: string;
  description: string;
  media: IMedia[];
  mainMedia: IMedia[];
  unSdg: IUnSdg[];
  likes: number;
  impactId: string;
  liked: boolean;
  quantityName: string;
  showUnSdg: boolean;
  aiGenerated: boolean;
}

export const AccountImpactDetails = (props: IProps) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('sm'));

  const isEmpty = !props.image || props.image.trim().length === 0;
  const isUiAvatar = props.image?.includes('ui-avatars.com/api');
  const showFallback = isEmpty || isUiAvatar;

  return (
    <Box id="account-impact-details__components-account-impacts__box__l38"
    sx={{
      boxSizing: 'border-box',
      position: 'relative',
      width: '100%',
      maxWidth: '800px',
      margin: '0 auto',
      padding: '5px 32px 20px',

      background: theme.palette.background.default
    }}>
      
      <Box id="account-impact-details__components-account-impacts__box__l50"
      sx={{
        padding: theme.spacing(2.5),
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2.5)
      }}>
        
        <Box id="account-impact-details__components-account-impacts__box__l58" sx={{ position: 'relative', pt: props.aiGenerated ? '22px' : 0 }}>
          {props.aiGenerated && <AIGeneratedBanner />}
          {showFallback ?
          <Box id="account-impact-details__components-account-impacts__box__l61"
          sx={{
            width: '100px',
            height: '100px',
            borderRadius: '10px',
            backgroundColor: theme.palette.background.paper,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}
          aria-label="fallback impact icon">
            
              <WorldHeartIcon size={80} color={'#666'} />
            </Box> :

          <AvatarImg id="account-impact-details__components-account-impacts__avatarimg__l77"
          borderRadius={'10px'}
          width={'100px'}
          src={props.image}
          alt={String(props.subtitle || props.title || 'impact')} />

          }
        </Box>

        <div id="account-impact-details__components-account-impacts__div__l86">
          <Box id="account-impact-details__components-account-impacts__box__l87"
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            columnGap: '5px',
            alignItems: 'baseline',
            pb: theme.spacing(0.5)
          }}>
            
            <Typography id="account-impact-details__components-account-impacts__typography__l96" sx={{ fontSize: '36px' }} variant="h2">
              {props.title}
            </Typography>
            <Typography id="account-impact-details__components-account-impacts__typography__l99" sx={{ margin: '10px 5px 10px 0px' }} variant="h4">
              {props.quantityName}
            </Typography>
          </Box>
          <Typography id="account-impact-details__components-account-impacts__typography__l103" sx={{ margin: '10px 5px 10px 0px' }} variant="subtitle2">
            {props.subtitle}
          </Typography>
        </div>
        {!isTablet && props.showUnSdg && <UnSdgList unSdg={props.unSdg} />}
      </Box>
      {props.mainMedia.length ?
      <Box id="account-impact-details__components-account-impacts__box__l110" sx={{ mb: theme.spacing(1.25) }}>
          <ImageCarousel isStep images={props.mainMedia} />
        </Box> :
      null}
      <Box id="account-impact-details__components-account-impacts__box__l114" sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(1.25), pb: '24px' }}>
        <LikesCounter count={props.likes} userLiked={props.liked} impactId={props.impactId} />
        {isTablet && props.showUnSdg &&
        <Box id="account-impact-details__components-account-impacts__box__l117" mx={'12px'}>
            <UnSdgList unSdg={props.unSdg} />
          </Box>
        }
        {props.description && props.description !== '<p><br></p>' ?
        <RichDescription html={props.description} sx={{ margin: '10px 12px' }} /> :
        null}
        {props.media.length >= 1 && <Divider id="account-impact-details__components-account-impacts__divider__l124" sx={{ borderColor: 'rgba(0,0,0,0.08);' }} />}
        {props.media.length >= 1 ? <MediaList media={props.media} /> : null}
      </Box>
    </Box>);

};